import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { API_BASE_URL } from './constants/apiConstants';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // use a http backend
  .use(HttpApi)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    backend: {
      loadPath:  API_BASE_URL+'translation/{{lng}}/{{ns}}.json',
      addPath:  API_BASE_URL+'translation-add/{{lng}}/{{ns}}',
      crossDomain: false,
      withCredentials: false
    },
    saveMissing: true,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;